import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Sunbed, SunbedForm, SunbedState } from '@shared-models';

export const sunbedFeatureSelector = createFeatureSelector<SunbedState>('sunbeds');

export const sunbedCartSelector = createSelector(
  sunbedFeatureSelector,
  (state: SunbedState): Sunbed[] => state.cartItems,
);

export const sunbedCartCounterSelector = createSelector(
  sunbedFeatureSelector,
  (state: SunbedState): number => state.cartItems.length,
);

export const sunbedFormSelector = createSelector(
  sunbedFeatureSelector,
  (state: SunbedState): SunbedForm => state.formData,
);

export const sunbedPriceSelector = createSelector(
  sunbedFeatureSelector,
  (state: SunbedState): number => {
    let sum = 0;
    for (const item of state.cartItems) {
      if (item.priceData.length) {
        sum += +item.priceData[0].projectedPriceWithDiscount;
      }
    }
    return sum;
  },
);

export const reservationsEnabledSelector = createSelector(
  sunbedFeatureSelector,
  (state: SunbedState): boolean => state.reservationsEnabled,
);

export const lastCartIdSelector = createSelector(
  sunbedFeatureSelector,
  (state: SunbedState): string => state.lastCartId,
);
